import React, { useState } from 'react';
import LoginScreen from './LoginScreen';
import RegisterScreen from './RegisterScreen';
import RequestReceivedScreen from './RequestReceivedScreen';

type View = 'login' | 'register' | 'requested';

/**
 * Unauthenticated entry point. Sign-in is a provider chooser (supplier via
 * IdPrism, employee via Midway) with no local password flow. A new supplier
 * with no account uses "Request access" to submit an onboarding request that an
 * approver reviews (POST /v1/onboarding/request); on approval the supplier is
 * created in IdPrism and signs in via "Supplier sign in". The former password
 * screens (confirm / MFA / set-new-password / forgot-password) are retired with
 * Cognito local auth.
 */
export default function AuthFlow() {
    const [view, setView] = useState<View>('login');
    const [requestedEmail, setRequestedEmail] = useState('');

    if (view === 'register') {
        return (
            <RegisterScreen
                onRequested={(email) => {
                    setRequestedEmail(email);
                    setView('requested');
                }}
                onGoToLogin={() => setView('login')}
            />
        );
    }

    if (view === 'requested') {
        return (
            <RequestReceivedScreen
                email={requestedEmail}
                onBackToLogin={() => setView('login')}
            />
        );
    }

    return <LoginScreen onRequestAccess={() => setView('register')} />;
}
